export const employerPOCMappingTo9142ASectionC = {
    name: "Employer POC Form Mapping",
    machine_name: "employer_9142A_profile_mapping",
    targetFormDetailName: "Form ETA-790",
    targetSectionName: "Requestor Point-of-Contact</br> Information",
    targetSectionLabel: "C",
    fields: [
      {
        profileFieldName: "poc_emp_last_name",
        formTargetField: "c1_poc_last"
      },
      {
        profileFieldName: "poc_emp_first_name",
        formTargetField: "c2_poc_first"
      },
      {
        profileFieldName: "poc_emp_middle_name",
        formTargetField: "c3_poc_middle"
      },
      {
        profileFieldName: "poc_emp_job_title",
        formTargetField: "c4_poc_title"
      },
      {
        profileFieldName: "poc_emp_address1",
        formTargetField: "c5_poc_address_1"
      },
      {
        profileFieldName: "poc_emp_address2",
        formTargetField: "c6_poc_address_2"
      },
      {
        profileFieldName: "poc_emp_city", //missing from the form?
        formTargetField: "c7_poc_city"
      },
      {
        profileFieldName: "poc_emp_country_id", //missing from the form?
        formTargetField: "c10_poc_country_id"
      },
      {
        profileFieldName: "poc_emp_state_id",
        formTargetField: "c8_poc_state_id"
      },
      {
        profileFieldName: "poc_emp_zip",
        formTargetField: "c9_poc_zip"
      },
      {
        profileFieldName: "poc_emp_province", //missing from the form?
        formTargetField: "c11_poc_province"
      },
      {
        profileFieldName: "poc_emp_phone",
        formTargetField: "c12_poc_phone"
      },
      {
        profileFieldName: "poc_emp_phone_ext",
        formTargetField: "c13_poc_phone_ext"
      },
      {
        profileFieldName: "poc_emp_email",
        formTargetField: "c14_poc_email"
      }
    ]
  };
  
  export const employerMappingTo9142ASectionB = {
    name: "Employer Profile Form Mapping",
    machine_name: "employer_9142A_profile_mapping",
    targetFormDetailName: "Form ETA-790",
    targetSectionName: "Employer Information",
    targetSectionLabel: "B",
    fields: [
      {
        profileFieldName: "new_profile_emp_legal_name",
        formTargetField: "b1_emp_legal_name"
      },
      {
        profileFieldName: "new_profile_emp_dba",
        formTargetField: "b2_emp_dba"
      },
      {
        profileFieldName: "new_profile_emp_address1",
        formTargetField: "b3_emp_address_1"
      },
      {
        profileFieldName: "new_profile_emp_address2",
        formTargetField: "b4_emp_address_2"
      },
      {
        profileFieldName: "new_profile_emp_city",
        formTargetField: "b5_emp_city"
      },
      {
        profileFieldName: "new_profile_emp_state_id",
        formTargetField: "b6_emp_state_id"
      },
      {
        profileFieldName: "new_profile_emp_zip",
        formTargetField: "b7_emp_zip"
      },
      {
        profileFieldName: "new_profile_emp_country_id",
        formTargetField: "b8_emp_country_id"
      },
      {
        profileFieldName: "new_profile_emp_province",
        formTargetField: "b9_emp_province"
      },
      {
        profileFieldName: "new_profile_emp_phone",
        formTargetField: "b10_emp_phone"
      },
      {
        profileFieldName: "new_profile_emp_phone_ext",
        formTargetField: "b11_emp_phone_ext"
      },
      {
        profileFieldName: "new_profile_emp_fein",
        formTargetField: "b12_emp_fein"
      },
      {
        profileFieldName: "new_profile_emp_naics_description",
        formTargetField: "b13_emp_naics_description"
      },
      {
        profileFieldName: "new_profile_emp_naics",
        formTargetField: "b13_emp_naics"
      },
    ]
  };
  